<!-- <thread-detail [config]="threadConfig" *ngIf="loaded" class="thread-detail-tile" [ngClass]="displaySettings">
</thread-detail> -->

<div *ngIf="loaded" [ngClass]="{'full-height':noData}">
    <div *ngFor="let threadConfig of threadConfigs" class="thread-detail">
        <thread-detail [config]="threadConfig" class="thread-detail-tile" [ngClass]="displaySettings">
        </thread-detail>
    </div>
    <div *ngIf="noData && !isPrintingMode" class="centralize-content">
        <div class="half-height flex-reverse">
            <span>No Notes Found</span>
        </div>
        <div class="half-height">
            <button tam-button tamType="primary" tamSize="normal" (click)="createNewNote()">New Note</button>
        </div>
    </div>
</div>
